import React from 'react';
import Order from './Order';
 
export default (props) => <Order {...props}/>;

